import { render, staticRenderFns } from "./MediaRefModal.vue?vue&type=template&id=5968f3fe&scoped=true"
import script from "./MediaRefModal.vue?vue&type=script&lang=js"
export * from "./MediaRefModal.vue?vue&type=script&lang=js"
import style0 from "./MediaRefModal.vue?vue&type=style&index=0&id=5968f3fe&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5968f3fe",
  null
  
)

export default component.exports